import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import LocalizationOverview from "./localization-overview"
import LocalizationLanguages from "./localization-languages"
import LocalizationKeys from "./localization-keys"

export default function LocalizationEditor() {
  // Custom tab resolver function for localization pages
  const customTabResolver = (defaultTab, context, pathname) => {
    // Extract the last part of the path to determine the tab
    const pathParts = pathname.split('/').filter(Boolean)
    const lastPart = pathParts[pathParts.length - 1]

    // Map URL endings to tab names
    if (lastPart === "overview") {
      return "overview"
    }
    if (lastPart === "keys") {
      return "keys"
    }
    if (lastPart === "languages") {
      return "languages"
    }

    // Default to overview tab for base localization URL
    if (pathname === "/admin/localization" || pathname === "/admin/localization/") {
      return "overview"
    }

    return undefined
  }

  return (
    <SidePanelLayout
      menuName="AdminLocalization"
      tabs={{
        overview: LocalizationOverview,
        languages: LocalizationLanguages,
        keys: LocalizationKeys,
      }}
      tabResolver={customTabResolver}
    />
  )
}